import { TYPES } from "../../types/types";

const initialState = {
  loading: false,
  loading2:false,
};

export const UIErrorReducer = (state = { ...initialState }, action) => {
  switch (action.type) {
    case TYPES.UISetError:
      return {
        ...state,
        msgError: action.payload.message,
        status: action.payload.statusCode,
      };

    case TYPES.UIRemoveError:
      return {
        ...state,
        msgError: null,
        status: null,
      };

    case TYPES.uiStartLoading:
      return {
        ...state,
        loading: true,
      };

    case TYPES.uiFinishLoading:
      return {
        ...state,
        loading: false,
      };

    case TYPES.uiStartLoading2:
      return {
        ...state,
        loading2: true,
      };

    case TYPES.uiFinishLoading2:
      return {
        ...state,
        loading2: false,
      };

    case TYPES.uiError500:
      return {
        ...state,
        error500: action.payload.error500 ? action.payload.error500 : "En estos momentos estamos presentando problemas en los servidores, intentelo más tarde.",
      };

    case TYPES.removeError500:
      return {
        ...state,
        error500: ""
      }


    default:
      return state;
  }
};
